/* CLOUDWEB-17847 [WEB] - Лимит на количество скачиваний с паблика на бесплатном аккаунте */

import { getFeature, isFeature } from 'Cloud/Application/FeaturesEs6';
import { IS_BIZ_USER, IS_CORP_USER, PROMO_TARIFFS } from 'reactApp/appHelpers/configHelpers';
import { registerExperiment } from 'reactApp/appHelpers/experimentAnalytic';
import { AnalyticEventNames } from 'reactApp/appHelpers/experimentAnalytic/eventNames';

// tempexp_17847-start
export const abPublicDownloadLimits: 'a' | 'b' | 'c' = getFeature('public-download-limits');

// промки
export const tooltipLimitSharing: boolean = isFeature('tooltip-limit-sharing');
export const tooltipTrackDownload: boolean = isFeature('tooltip-track-download');
export const tooltipLimitPublic: boolean = isFeature('tooltip-limit-public');

// включение на b и c
export const enabledPublicDownloadLimits: boolean =
    !IS_BIZ_USER && !IS_CORP_USER && (abPublicDownloadLimits === 'b' || abPublicDownloadLimits === 'c');
export const limitForPublic: number = getFeature('public-download-limit-total');

// export const enabledPublicDownloadLimits: boolean = true;
// export const limitForPublic: number = 2;

export const trialTariff = PROMO_TARIFFS?.publicLimitTrial || 'W64GB_1m_unlimit_public_force_trial';
export const fullTariff = PROMO_TARIFFS?.publicLimit || 'W64GB_1m_unlimit_public';

// tempexp_17847-end

registerExperiment(
    'download-limit-publics',
    abPublicDownloadLimits,
    [
        AnalyticEventNames.PUBLIC_LIMIT_PROMO_SHARING_SHOW,
        AnalyticEventNames.PUBLIC_LIMIT_PROMO_SHARING_CLOSE,
        AnalyticEventNames.PUBLIC_LIMIT_PROMO_SHARING_CLICK,
        AnalyticEventNames.PUBLIC_LIMIT_PROMO_LIST_SHOW,
        AnalyticEventNames.PUBLIC_LIMIT_PROMO_LIST_CLOSE,
        AnalyticEventNames.PUBLIC_LIMIT_PROMO_LIST_CLICK,
        AnalyticEventNames.PUBLIC_LIMIT_PROMO_LINK_SHOW,
        AnalyticEventNames.PUBLIC_LIMIT_PROMO_LINK_CLOSE,
        AnalyticEventNames.PUBLIC_LIMIT_PROMO_LINK_CLICK,
        AnalyticEventNames.INFORMER_SHARING_SHOW,
        AnalyticEventNames.INFORMER_SHARING_CLICK,
        AnalyticEventNames.INFORMER_HOME_SHOW,
        AnalyticEventNames.INFORMER_HOME_CLICK,
        AnalyticEventNames.INFORMER_HOME_CLOSE,
        AnalyticEventNames.FAST_CHECKOUT_SHOWN,
        AnalyticEventNames.TARIFF_BUY,
        AnalyticEventNames.TRIAL_TARIFF_BUY,
    ],
    {
        sendXrayArgs: {
            [AnalyticEventNames.FAST_CHECKOUT_SHOWN]: ({ paySource }, { eventName }) => ({
                eventName: paySource?.startsWith('limit_sharing') ? 'ls_checkout' : eventName,
            }),
            [AnalyticEventNames.TARIFF_BUY]: ({ paySource }, { eventName }) => ({
                eventName: paySource?.startsWith('limit_sharing') ? 'ls_buy' : eventName,
            }),
        },
    }
);
